import { RefreshCw } from 'lucide-react';

import { Separator } from '@/components/ui/separator';
import { cn } from 'src/lib/utils';
import { productTypeMap } from 'src/shared/mappings/productTypeMap';

import {
  useAppCard,
  type ProductSlot,
  groupProductsByStatus,
  isActiveStatus,
  isNotAddedStatus,
  isProductVisible,
} from '../model';

const ProductIcon = ({ product }: { product: ProductSlot }) => {
  const { icon: Icon, label: productLabel } = productTypeMap[product.productType];
  const isInProgress = !isActiveStatus(product.status) && !isNotAddedStatus(product.status);

  return (
    <div className="relative" data-status={product.status ?? 'not_added'}>
      <Icon
        aria-label={productLabel}
        className={cn('size-7', isNotAddedStatus(product.status) && 'opacity-40 size-4.5')}
      />
      {isInProgress && (
        <span
          data-testid="app-card-product-in-progress-badge"
          className="absolute -top-1 -right-1 flex items-center justify-center size-3.5 rounded-full bg-white"
          aria-hidden="true"
        >
          <RefreshCw className="size-3 text-muted-foreground" />
        </span>
      )}
    </div>
  );
};

const ProductRow = () => {
  const { data } = useAppCard();
  const visibleProducts = data.products.filter((product) => isProductVisible(product.productType, data.owned));
  const { actedUpon, notAdded } = groupProductsByStatus(visibleProducts);

  return (
    <div className="flex items-center">
      {actedUpon.map((product, index) => (
        <ProductIcon key={`acted-upon-${product.productType}-${index}`} product={product} />
      ))}
      {actedUpon.length > 0 && notAdded.length > 0 && (
        <Separator data-testid="app-card-product-divider" orientation="vertical" className="h-5 mx-1.5" />
      )}
      {notAdded.map((product, index) => (
        <ProductIcon key={`not-added-${product.productType}-${index}`} product={product} />
      ))}
    </div>
  );
};

export { ProductRow };
